import * as React from "react";
// import { useState, useEffect } from "react";
import { WordCloud } from "@ant-design/plots";

const WordCloudChart = ({ data }) => {
  const config = {
    data,
    wordField: "name",
    weightField: "value",
    color: "green",
    wordStyle: {
      fontFamily: "Verdana",
      fontSize: [5, 80],
    },
    interactions: [
      {
        type: "element-active",
      },
    ],
    // state: {
    //   active: {
    //     style: {
    //       lineWidth: 3,
    //     },
    //   },
    // },
  };

  return (
    <div style={{ minWidth: "450px" }} className="">
      <WordCloud {...config} />
    </div>
  );
};

export default WordCloudChart;
